export * from './splash-screen.module';
